import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=10b83758&scoped=true&"
import script from "./file-list.vue?vue&type=script&lang=js&"
export * from "./file-list.vue?vue&type=script&lang=js&"
import style0 from "./file-list.vue?vue&type=style&index=0&id=10b83758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b83758",
  null
  
)

export default component.exports